// Every user-facing string. ja and en must have the same keys (tests/i18n.test.js).
import { meta } from './locales-meta.js';
export const resources = {
  ja: {
    translation: {
      title: '月ノ浦',
      subtitle: '今夜の潮だまり',
      lang: 'English',
      date: '{{y}}年{{m}}月{{d}}日の夜',
      moonAge: '月齢 {{age}}',
      tide: { oshio: '大潮', nakashio: '中潮', koshio: '小潮', nagashio: '長潮', wakashio: '若潮' },
      tideLine: {
        oshio: '大潮の夜。潮が遠くまで引き、淵の主が起きています。',
        nakashio: '中潮の夜。淵まで潮が引きました。主の機嫌はよくありません。',
        koshio: '小潮の夜。潮はあまり引かず、引き潮がゆっくり寄せてきます。',
        nagashio: '長潮の夜。潮がのんびり動き、藻があちこちに残っています。',
        wakashio: '若潮の夜。潮の向きが変わり、引き潮の足が速くなります。',
      },
      crew: '磯番',
      seat: { human: '人', bot: '相棒' },
      crab: { goro: 'ゴロ', bou: 'ボウ', chika: 'チカ', mio: 'ミオ' },
      shell: { goro: 'サザエ', bou: 'ホラガイ', chika: 'タカラガイ', mio: 'ツメタガイ' },
      start: '潮だまりへ',
      howto: {
        one: '殻を引っ張って放すと、航跡に夜光虫が光ります。',
        two: '航跡と岩と岸で黒い引き潮から切り離した水は「灯の囲い」になり、中の迷い子が助かります。',
        three: '全員が狙いを決めると、四匹が同時に飛びます。',
      },
      practice: '練習（記録しません）',
      hud: {
        pool: '{{n}} / {{total}} 番目の潮だまり',
        fuchi: '淵',
        tide: '潮が戻るまで',
        turns: '{{n}} 手',
        saved: '迷い子',
        poolSaved: 'この潮だまりで助けた迷い子',
        bossWater: '主の水域（{{goal}}% まで囲うと眠ります）',
        nightSaved: '今夜 {{n}} / {{total}}',
        aim: '{{name}} の番です。引いて放してください。',
        aimHint: '短く放すと取り消しです。点線は最初に当たる所までの軌道です。',
        thinking: '相棒が狙いを考えています',
        go: '放て',
        skip: 'タップで早送り',
        locked: '決定',
        wait: '待機',
        back: '一つ戻す',
        coach1: '迷い子を黒い引き潮から守ります。迷い子と引き潮のあいだを航跡で仕切ると、その水が灯ります。',
      },
      pool: {
        ichi: '一ノ溜', ni: '二ノ溜', san: '三ノ溜', shi: '四ノ溜', go: '五ノ溜', fuchi: '淵',
      },
      event: {
        clear: 'この潮だまりは灯りました',
        tideBack: '潮が戻ってきました',
        calm: '主が眠りました',
        four: '四人の囲い',
        horn: '法螺の音',
        pearl: '真珠',
        sent: '{{name}} の灯籠が海へ',
        netted: '網に入った',
        faded: '光に紛れた',
        picture: '絵が浮かびました',
        next: '次の潮だまりへ',
      },
      end: {
        title: '今夜の記録',
        dawn: '夜明け前に磯を回りきりました。',
        tide: '潮が戻り、磯番は浜へ帰りました。',
        pools: '灯した潮だまり',
        tideLeft: '残った潮',
        pens: '灯の囲い',
        four: '四人の囲い',
        bestPen: '一度に助けた最多',
        share: '結果をコピー',
        beach: '夜明けの浜へ',
        glass: '今夜の色ガラス',
        copied: 'コピーしました',
        tomorrow: '明日は{{tide}}です。',
        again: 'もう一度（練習）',
        title2: 'タイトルへ',
      },
      settings: { title: '設定', sound: '音', motion: '画面の揺れ', on: 'あり', off: 'なし' },
      art: '絵と音は試作用で、Blender と Web Audio で生成しています。',
    },
  },
  en: {
    translation: {
      title: 'Tsukinoura',
      subtitle: "Tonight's Tide Pools",
      lang: '日本語',
      date: 'The night of {{m}}/{{d}}/{{y}}',
      moonAge: 'Moon age {{age}}',
      tide: { oshio: 'Spring tide', nakashio: 'Middle tide', koshio: 'Neap tide', nagashio: 'Long tide', wakashio: 'Young tide' },
      tideLine: {
        oshio: 'A spring tide. The sea has pulled far out, and the old one in the deep pool is awake.',
        nakashio: 'A middle tide. The water is out past the deep pool, and its old one is in a bad mood.',
        koshio: 'A neap tide. The sea stays close, and the undertow creeps in slowly.',
        nagashio: 'A long tide. The water moves lazily and leaves kelp everywhere.',
        wakashio: 'A young tide. The tide is turning, and the undertow runs fast.',
      },
      crew: 'Shore wardens',
      seat: { human: 'Player', bot: 'Partner' },
      crab: { goro: 'Goro', bou: 'Bou', chika: 'Chika', mio: 'Mio' },
      shell: { goro: 'turban shell', bou: 'triton', chika: 'cowrie', mio: 'moon snail' },
      start: 'Go to the pools',
      howto: {
        one: 'Pull a shell back and let go. Its wake lights up the sea sparkle.',
        two: 'Water that wakes, rocks and the rim cut off from the dark undertow becomes a light pen. Little ones inside are safe.',
        three: 'When everyone has aimed, all four shells fly at once.',
      },
      practice: 'Practice (not recorded)',
      hud: {
        pool: 'Pool {{n}} of {{total}}',
        fuchi: 'Deep pool',
        tide: 'Tide returns in',
        turns: '{{n}} turns',
        saved: 'Little ones',
        poolSaved: 'Saved in this pool',
        bossWater: "The old one's water (fence it to {{goal}}% and it sleeps)",
        nightSaved: 'Tonight {{n}} / {{total}}',
        aim: "{{name}}'s turn. Pull back and let go.",
        aimHint: 'Let go near the start to cancel. Dots show the path to the first contact.',
        thinking: 'Partners are aiming',
        go: 'Go',
        skip: 'Tap to speed up',
        locked: 'Ready',
        wait: 'Waiting',
        back: 'Undo one',
        coach1: 'Keep the little ones from the dark undertow. Cut the water between them with your wakes, and it lights up.',
      },
      pool: {
        ichi: 'First Pool', ni: 'Second Pool', san: 'Third Pool', shi: 'Fourth Pool', go: 'Fifth Pool', fuchi: 'Deep Pool',
      },
      event: {
        clear: 'This pool is lit',
        tideBack: 'The tide is back',
        calm: 'The old one sleeps',
        four: 'Four-way pen',
        horn: 'Conch call',
        pearl: 'Pearl',
        sent: "{{name}}'s lantern goes to sea",
        netted: 'In the net',
        faded: 'Washed out',
        picture: 'The picture appears',
        next: 'On to the next pool',
      },
      end: {
        title: "Tonight's record",
        dawn: 'You walked the whole shelf before dawn.',
        tide: 'The tide came back, and the wardens went home.',
        pools: 'Pools lit',
        tideLeft: 'Tide left',
        pens: 'Light pens',
        four: 'Four-way pens',
        bestPen: 'Most saved at once',
        share: 'Copy result',
        beach: 'To the beach at dawn',
        glass: "Tonight's glass",
        copied: 'Copied',
        tomorrow: 'Tomorrow is a {{tide}}.',
        again: 'Play again (practice)',
        title2: 'Title',
      },
      settings: { title: 'Settings', sound: 'Sound', motion: 'Screen shake', on: 'On', off: 'Off' },
      art: 'Art and sound are prototypes made with Blender and Web Audio.',
    },
  },
};
for (const lang of ['ja', 'en']) Object.assign(resources[lang].translation, meta[lang]);
